import React from 'react';

import router, { RouteNode } from '../../config/router';
import TimeEstimator from './TimeEstimator';

const timeEstimator = new RouteNode('Time Estimation', '/time-estimation', <TimeEstimator />);
router.addRoute(timeEstimator);
